<template>
  <div class="page page-work" @keydown.esc="closeInfo">
    <div class="pagewrap">
      <div class="work">
        <app-work-item
          v-for="(site, index) in websites"
          :site="site"
          :key="site + index"
          @cacheVideo="cacheVideo($event, index)"
          @openInfo="openInfo"
        ></app-work-item>
        <transition :name="transition" mode="out-in">
          <router-view
            :currentIndex="currentIndex"
            @changeCurrentWebsite="changeCurrentWebsite"
            @closeInfo="closeInfo"
          ></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import Work from "../components/Work.vue";
import Close from "../components/svg/Close.vue";
import { eventBus } from "../main";
import { isMobileSafari } from "../main";
const increment = 0.075;
const scrollSettings = {
  alignToTop: true,
  behavior: "instant",
  block: "start",
  inline: "start"
};
function preFetchVideo(videoSrc) {
  const video = document.createElement("video");
  video.preload = "auto";
  video.src = videoSrc;
}
export default {
  components: {
    appWorkItem: Work,
    appClose: Close
  },
  data() {
    return {
      strikethrough: "strikethrough",
      nextWorkItem: null,
      currentIndex: 0,
      cachedIndex: null,
      workItemOpened: false,
      vidBase: "https://d12dfyjdyr4tom.cloudfront.net/",
      isMobileSafari: isMobileSafari,
      workItems: this.$store.state.globals.workItems
    };
  },
  methods: {
    cacheVideo(currentWorkItem, index) {
      this.currentWorkItem = currentWorkItem;
      this.currentIndex = index;
      if (!currentWorkItem.video.url) return;
      preFetchVideo(currentWorkItem.video.url);
    },
    cacheVideoModalOpen(index) {
      let itemToCache = this.websites[index];
      this.nextWorkItem = itemToCache;
      if (!itemToCache || !itemToCache.video.url) return;
      this.cachedIndex = index;
      preFetchVideo(itemToCache.video.url);
    },
    changeCurrentWebsite(index) {
      let prevWorkItem, nextWorkItem;
      if (index === -1 || index === this.websites.length - 1) {
        prevWorkItem = this.websites.length - 2;
        nextWorkItem = 0;
      } else if (index === 0) {
        prevWorkItem = this.websites.length - 1;
        nextWorkItem = index + 1;
      } else if (index === this.websites.length) {
        prevWorkItem = this.websites.length - 1;
        nextWorkItem = 1;
      } else {
        this.currentWorkItem = this.websites[index];
        this.currentIndex = index;
        prevWorkItem = index - 1;
        nextWorkItem = index + 1;
      }
      this.cacheVideoModalOpen(prevWorkItem);
      this.cacheVideoModalOpen(nextWorkItem);
      this.$router.push(
        `/work/${this.workItems[index].title
          .replace(/\s+/g, "-")
          .toLowerCase()}`
      );
      const contentBox = this.$el.querySelector(".content-wrap");
      if (window.innerWidth > window.innerHeight) {
        contentBox.scrollIntoView(scrollSettings);
      }
    },
    openInfo() {
      this.workItemOpened = true;
      this.$router.push(
        `/work/${this.currentWorkItem.title.replace(/\s+/g, "-").toLowerCase()}`
      );
      eventBus.$emit("aboutWindowOpened", true);
      if (this.currentIndex === 0) {
        this.cacheVideoModalOpen(this.websites.length - 1);
      }
      if (
        this.currentIndex < this.websites.length - 1 ||
        this.currentIndex == 0
      ) {
        this.cacheVideoModalOpen(this.currentIndex + 1);
      }
      if (this.currentIndex > 0) {
        this.cacheVideoModalOpen(this.currentIndex - 1);
      }
      if (this.currentIndex === this.websites.length - 1) {
        this.cacheVideoModalOpen(0);
      }
    },
    closeInfo() {
      this.$router.push("/work");
      this.workItemOpened = false;
      eventBus.$emit("aboutWindowClosed", false);
    }
  },
  props: ["images", "transition"],
  computed: {
    hasUrl() {
      return this.currentWorkItem.url;
    },
    websites() {
      return this.workItems;
    }
  },
  created() {
    let animationDelay = 0;
    for (let site of this.websites) {
      site.animationDelay = animationDelay;
      animationDelay += increment;
    }
  }
};
</script>
